'use client';

import * as React from 'react';
import { HandCoinsIcon, ScanBarcodeIcon } from 'lucide-react';
import { motion } from 'motion/react';

import {
  Card,
  CardContent,
  CardHeader,
  CardTitle
} from '@workspace/ui/components/card';
import { cn } from '@workspace/ui/lib/utils';

const MotionCard = motion.create(Card);

export function BentoTaxAdvisorCard({
  className,
  ...other
}: React.ComponentPropsWithoutRef<typeof MotionCard>): React.JSX.Element {
  return (
    <MotionCard
      className={cn(
        'relative h-[300px] max-h-[300px] overflow-hidden',
        className
      )}
      {...other}
    >
      <CardHeader>
        <CardTitle className="text-xl font-semibold">Steuerberater</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <p className="line-clamp-2 text-sm text-muted-foreground">
          Exportieren Sie alle Daten DATEV-konform für Ihren Steuerberater.
        </p>
        <div className="flex flex-col gap-4">
          <div className="flex items-center justify-between gap-2 rounded-lg border p-3 shadow-sm sm:p-4">
            <div className="flex min-w-0 items-center gap-2 sm:gap-3">
              <div className="shrink-0 rounded-md bg-primary/10 p-2 text-primary">
                <ScanBarcodeIcon className="size-4 sm:size-5" />
              </div>
              <div className="min-w-0">
                <p className="truncate text-sm font-medium">DATEV Export</p>
                <p className="truncate text-[10px] text-muted-foreground sm:text-xs">Debitoren, Kreditoren, Buchungen & Belege</p>
              </div>
            </div>
            <div className="shrink-0 text-[10px] font-semibold text-[hsl(var(--chart-1))] dark:text-[hsl(var(--chart-1))] sm:text-xs">
              Bereit
            </div>
          </div>

          <div className="flex items-center justify-between gap-2 rounded-lg border p-3 shadow-sm sm:p-4">
            <div className="flex min-w-0 items-center gap-2 sm:gap-3">
              <div className="shrink-0 rounded-md bg-secondary/10 p-2 text-secondary">
                <HandCoinsIcon className="size-4 sm:size-5" />
              </div>
              <div className="min-w-0">
                <p className="truncate text-sm font-medium">USt-Voranmeldung</p>
                <p className="truncate text-[10px] text-muted-foreground sm:text-xs">Erstellung starten</p>
              </div>
            </div>
            <div className="shrink-0 text-[10px] font-semibold text-muted-foreground sm:text-xs">
              Ausstehend
            </div>
          </div>
        </div>
      </CardContent>
    </MotionCard>
  );
}

